// Kind/source classification shared by OrderActivity (system-events collapse)
// and ActivityRow (category dot + label). Single source of truth so the two
// don't drift into different matching styles — see decision U4 postmortem.
//
// Source: internal/orderactivity/domain.go Kind* constants (verified against
// the real backend source, not guessed).

// Kinds collapsed under "Show N system events" by default (decision U4).
const SYSTEM_KIND_PREFIXES = [
  "warehouse.picked",
  "warehouse.packed",
  "stock.",
  "marketplace.settlement",
  "lifecycle.reserved",
];

export function isSystemKind(kind: string): boolean {
  return SYSTEM_KIND_PREFIXES.some((p) => kind.startsWith(p));
}

// Maps ActivityEvent.source ("marketplace" | "warehouse" | "atlas" | "people")
// to an activity_kind taxonomy code. `atlas` gets its own code — most
// `SourceAtlas` kinds (lifecycle.received/reserved, atlas.flagged,
// atlas.ship_by, etc.) are Atlas-native, not warehouse operations, and must
// agree with the "Atlas" filter chip for the same rows.
const CATEGORY_INTENT_CODE: Record<string, string> = {
  marketplace: "marketplace",
  warehouse: "warehouse",
  atlas: "atlas",
  people: "note",
};

export function categoryFor(item: { kind: string; source: string }): string {
  if (item.kind.startsWith("stock.")) return "stock";
  if (item.kind.includes("settlement")) return "settlement";
  return CATEGORY_INTENT_CODE[item.source] ?? "note";
}
